import { render, staticRenderFns } from "./PostDates.vue?vue&type=template&id=65107522&scoped=true"
import script from "./PostDates.vue?vue&type=script&lang=js"
export * from "./PostDates.vue?vue&type=script&lang=js"
import style0 from "./PostDates.vue?vue&type=style&index=0&id=65107522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65107522",
  null
  
)

export default component.exports